import { applePost, facebookSSO } from "../shared/sso"
import handleRecaptcha from "shared/handle_recaptcha"
import RefreshFormAuthenticityToken from "app/scripts/refresh_form_authenticity_token"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import UnifiedProfileDropdown from "shared/components/unified_profile_dropdown"
import ProsumerHome from "app/components/prosumer_home"
import PlanUpgradeButton from "app/components/plan_upgrade_button"
import FeedbackPrompt from "app/components/feedback_prompt/index.tsx"
import SetupUnifiedHeaderDropdown from "shared/scripts/setup_unified_header_dropdown"
import PasswordUnmasking from "shared/scripts/password_un_masking"
import setupLazyLoad from "app/scripts/setup_lazy_load"
import ToggleHelpWidgetVisibility from "shared/scripts/toggle_help_widget_visibility"

Object.assign(window.App.Comps, {
  PlanUpgradeButton,
  UnifiedProfileDropdown,
  FeedbackPrompt,
})

Object.assign(window.App.Scripts, {
  applePost,
  facebookSSO,
  handleRecaptcha,
  RefreshFormAuthenticityToken,
  SetupUnifiedMobileMenu,
  PasswordUnmasking,
  ProsumerHome,
  SetupUnifiedHeaderDropdown,
  setupLazyLoad,
  ToggleHelpWidgetVisibility,
})
